/*
<firebase-file-upload>
  <label for="firebase-file-upload-file">
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
      <g clip-path="url(#firebase-file-upload-file-icon)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.90234 0.0600586C7.58259 0.0644558 6.30783 0.570202 5.30834 1.48593C4.54234 2.18718 3.98734 3.10093 3.84434 4.01787C2.16834 4.411 0.902344 5.96225 0.902344 7.83543C0.902344 10.0114 2.61034 11.7476 4.68334 11.7476H8.40234V6.12375L6.25634 8.40493C6.16246 8.50469 6.03512 8.56073 5.90234 8.56073C5.76957 8.56073 5.64223 8.50469 5.54834 8.40493C5.45446 8.30518 5.40171 8.16988 5.40171 8.02881C5.40171 7.88773 5.45446 7.75244 5.54834 7.65268L8.54834 4.46518C8.59479 4.41571 8.64996 4.37646 8.71071 4.34968C8.77146 4.32289 8.83658 4.30911 8.90234 4.30911C8.96811 4.30911 9.03323 4.32289 9.09398 4.34968C9.15472 4.37646 9.2099 4.41571 9.25634 4.46518L12.2563 7.65268C12.3502 7.75244 12.403 7.88773 12.403 8.02881C12.403 8.16988 12.3502 8.30518 12.2563 8.40493C12.1625 8.50469 12.0351 8.56073 11.9023 8.56073C11.7696 8.56073 11.6422 8.50469 11.5483 8.40493L9.40234 6.12375V11.7476H13.5903C15.4043 11.7476 16.9023 10.2282 16.9023 8.31887C16.9023 6.58062 15.6603 5.16431 14.0683 4.92525C13.8253 2.184 11.5923 0.0600586 8.90234 0.0600586ZM8.40234 15.4663V11.7476H9.40234V15.4663C9.40234 15.6072 9.34967 15.7423 9.2559 15.842C9.16213 15.9416 9.03495 15.9976 8.90234 15.9976C8.76974 15.9976 8.64256 15.9416 8.54879 15.842C8.45502 15.7423 8.40234 15.6072 8.40234 15.4663Z" fill="black"/>
      </g>
      <defs><clipPath id="firebase-file-upload-file-icon"><rect width="16" height="17" fill="white" transform="translate(0.902344 0.0600586)"/></clipPath></defs>
    </svg>
    <span>Upload File</span>
  </label>
  <input id="firebase-file-upload-file" type="file" name="firebase-file-upload-file" hidden />
  <input class="firebase-file-upload-downloadUrl" type="hidden" name="properties[Prescription File]" disabled />
  <div class="upload-progress">
    <div class="upload-progress--bar">
      <div class="upload-progress--bar--indicator"></div>
    </div>
    <div class="upload-progress--percent">0%</div>
  </div>
  <div class="upload-result">
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="24" viewBox="0 0 28 24" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0H21C21.9283 0 22.8185 0.316071 23.4749 0.87868C24.1313 1.44129 24.5 2.20435 24.5 3V15.4395L19.7225 11.3445C19.5427 11.1908 19.3259 11.0724 19.0874 10.9977C18.8488 10.923 18.5941 10.8937 18.341 10.9118C18.0879 10.9299 17.8425 10.9951 17.6217 11.1027C17.4009 11.2103 17.2101 11.3578 17.0625 11.535L13.7568 15.501L10.661 13.908C10.3263 13.7357 9.93406 13.6642 9.54656 13.705C9.15906 13.7457 8.7986 13.8964 8.5225 14.133L3.5 18.438V3C3.5 2.20435 3.86875 1.44129 4.52513 0.87868C5.1815 0.316071 6.07174 0 7 0V0ZM18.487 12.405L24.5 17.562V21C24.5 21.7956 24.1313 22.5587 23.4749 23.1213C22.8185 23.6839 21.9283 24 21 24H7C6.07174 24 5.1815 23.6839 4.52513 23.1213C3.86875 22.5587 3.5 21.7956 3.5 21V20.5605L9.7615 15.195L13.5503 17.1435L14.2432 17.499L14.7122 16.9365L18.487 12.4065V12.405ZM14.0035 8.25C14.0035 8.84674 13.7269 9.41903 13.2347 9.84099C12.7424 10.2629 12.0747 10.5 11.3785 10.5C10.6823 10.5 10.0146 10.2629 9.52235 9.84099C9.03006 9.41903 8.7535 8.84674 8.7535 8.25C8.7535 7.65326 9.03006 7.08097 9.52235 6.65901C10.0146 6.23705 10.6823 6 11.3785 6C12.0747 6 12.7424 6.23705 13.2347 6.65901C13.7269 7.08097 14.0035 7.65326 14.0035 8.25Z" fill="#1B3F96"/>
    </svg>
    <span class="upload-result--filename"></span>
    <button class="upload-result--delete">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M6.1875 6.1875C6.33668 6.1875 6.47976 6.24676 6.58525 6.35225C6.69074 6.45774 6.75 6.60082 6.75 6.75V13.5C6.75 13.6492 6.69074 13.7923 6.58525 13.8977C6.47976 14.0032 6.33668 14.0625 6.1875 14.0625C6.03832 14.0625 5.89524 14.0032 5.78975 13.8977C5.68426 13.7923 5.625 13.6492 5.625 13.5V6.75C5.625 6.60082 5.68426 6.45774 5.78975 6.35225C5.89524 6.24676 6.03832 6.1875 6.1875 6.1875ZM9 6.1875C9.14918 6.1875 9.29226 6.24676 9.39775 6.35225C9.50324 6.45774 9.5625 6.60082 9.5625 6.75V13.5C9.5625 13.6492 9.50324 13.7923 9.39775 13.8977C9.29226 14.0032 9.14918 14.0625 9 14.0625C8.85082 14.0625 8.70774 14.0032 8.60225 13.8977C8.49676 13.7923 8.4375 13.6492 8.4375 13.5V6.75C8.4375 6.60082 8.49676 6.45774 8.60225 6.35225C8.70774 6.24676 8.85082 6.1875 9 6.1875ZM12.375 6.75C12.375 6.60082 12.3157 6.45774 12.2102 6.35225C12.1048 6.24676 11.9617 6.1875 11.8125 6.1875C11.6633 6.1875 11.5202 6.24676 11.4148 6.35225C11.3093 6.45774 11.25 6.60082 11.25 6.75V13.5C11.25 13.6492 11.3093 13.7923 11.4148 13.8977C11.5202 14.0032 11.6633 14.0625 11.8125 14.0625C11.9617 14.0625 12.1048 14.0032 12.2102 13.8977C12.3157 13.7923 12.375 13.6492 12.375 13.5V6.75Z" fill="#1B3F96"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3125 3.375C16.3125 3.67337 16.194 3.95952 15.983 4.1705C15.772 4.38147 15.4859 4.5 15.1875 4.5H14.625V14.625C14.625 15.2217 14.3879 15.794 13.966 16.216C13.544 16.6379 12.9717 16.875 12.375 16.875H5.625C5.02826 16.875 4.45597 16.6379 4.03401 16.216C3.61205 15.794 3.375 15.2217 3.375 14.625V4.5H2.8125C2.51413 4.5 2.22798 4.38147 2.017 4.1705C1.80603 3.95952 1.6875 3.67337 1.6875 3.375V2.25C1.6875 1.95163 1.80603 1.66548 2.017 1.4545C2.22798 1.24353 2.51413 1.125 2.8125 1.125H6.75C6.75 0.826631 6.86853 0.540483 7.0795 0.329505C7.29048 0.118526 7.57663 0 7.875 0L10.125 0C10.4234 0 10.7095 0.118526 10.9205 0.329505C11.1315 0.540483 11.25 0.826631 11.25 1.125H15.1875C15.4859 1.125 15.772 1.24353 15.983 1.4545C16.194 1.66548 16.3125 1.95163 16.3125 2.25V3.375ZM4.63275 4.5L4.5 4.56637V14.625C4.5 14.9234 4.61853 15.2095 4.8295 15.4205C5.04048 15.6315 5.32663 15.75 5.625 15.75H12.375C12.6734 15.75 12.9595 15.6315 13.1705 15.4205C13.3815 15.2095 13.5 14.9234 13.5 14.625V4.56637L13.3673 4.5H4.63275ZM2.8125 3.375V2.25H15.1875V3.375H2.8125Z" fill="#1B3F96"/>
      </svg>
    </button>
  </div>
  <div class="upload-error">
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="24" viewBox="0 0 26 24" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4726 2.34893C13.3241 2.09027 13.11 1.87538 12.8519 1.72594C12.5938 1.5765 12.3008 1.4978 12.0026 1.4978C11.7043 1.4978 11.4113 1.5765 11.1532 1.72594C10.8951 1.87538 10.681 2.09027 10.5326 2.34893L0.247053 19.8494C-0.438447 21.0164 0.383553 22.4999 1.71705 22.4999H22.2866C23.6201 22.4999 24.4436 21.0149 23.7566 19.8494L13.4726 2.34893ZM11.9996 7.49993C11.81 7.50003 11.6225 7.53985 11.4492 7.61682C11.276 7.69379 11.1207 7.80619 10.9936 7.94679C10.8664 8.0874 10.7701 8.25308 10.7108 8.43318C10.6516 8.61327 10.6307 8.80378 10.6496 8.99243L11.1746 14.2529C11.1922 14.4596 11.2867 14.6521 11.4395 14.7924C11.5923 14.9327 11.7921 15.0105 11.9996 15.0105C12.207 15.0105 12.4068 14.9327 12.5596 14.7924C12.7124 14.6521 12.8069 14.4596 12.8246 14.2529L13.3496 8.99243C13.3684 8.80378 13.3475 8.61327 13.2883 8.43318C13.229 8.25308 13.1327 8.0874 13.0055 7.94679C12.8784 7.80619 12.7231 7.69379 12.5499 7.61682C12.3766 7.53985 12.1891 7.50003 11.9996 7.49993ZM12.0026 16.4999C11.6047 16.4999 11.2232 16.658 10.9419 16.9393C10.6606 17.2206 10.5026 17.6021 10.5026 17.9999C10.5026 18.3978 10.6606 18.7793 10.9419 19.0606C11.2232 19.3419 11.6047 19.4999 12.0026 19.4999C12.4004 19.4999 12.7819 19.3419 13.0632 19.0606C13.3445 18.7793 13.5026 18.3978 13.5026 17.9999C13.5026 17.6021 13.3445 17.2206 13.0632 16.9393C12.7819 16.658 12.4004 16.4999 12.0026 16.4999Z" fill="#862A2F"/>
    </svg>
    <span class="upload-error--message"></span>
  </div>
</firebase-file-upload>
*/

import {initializeApp} from "https://www.gstatic.com/firebasejs/10.1.0/firebase-app.js";
import {getStorage, ref, uploadBytesResumable, getDownloadURL} from 'https://www.gstatic.com/firebasejs/10.1.0/firebase-storage.js';

class FirebaseFileUpload {
  acceptedFiles=
    'image/png, image/jpeg, image/gif, image/avif, image/tiff, image/webp, ' +
    'application/pdf, ' +
    'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, ' +
    'application/vnd.oasis.opendocument.spreadsheet, application/vnd.oasis.opendocument.text';

  maxFileSize = 10 * 1024 * 1024; // 1MB

  firebaseConfig= {
    apiKey: "\x41\x49\x7A\x61\x53\x79\x42\x61\x67\x45\x4E\x5A\x49\x6A\x74\x54\x52\x56\x42\x77\x35\x6C\x61\x50\x4F\x36\x76\x55\x6C\x69\x4E\x6C\x4C\x56\x77\x6D\x4F\x76\x49",
    authDomain: "\x62\x6F\x6E\x63\x68\x61\x72\x67\x65\x66\x69\x6C\x65\x75\x70\x6C\x6F\x61\x64\x2E\x66\x69\x72\x65\x62\x61\x73\x65\x61\x70\x70\x2E\x63\x6F\x6D",
    projectId: "\x62\x6F\x6E\x63\x68\x61\x72\x67\x65\x66\x69\x6C\x65\x75\x70\x6C\x6F\x61\x64",
    storageBucket: "\x62\x6F\x6E\x63\x68\x61\x72\x67\x65\x66\x69\x6C\x65\x75\x70\x6C\x6F\x61\x64\x2E\x61\x70\x70\x73\x70\x6F\x74\x2E\x63\x6F\x6D",
    messagingSenderId: "\x31\x32\x39\x36\x31\x38\x30\x30\x31\x38\x31\x33",
    appId: "\x31\x3A\x31\x32\x39\x36\x31\x38\x30\x30\x31\x38\x31\x33\x3A\x77\x65\x62\x3A\x32\x64\x33\x32\x36\x61\x36\x34\x37\x64\x30\x61\x63\x33\x65\x31\x33\x34\x63\x30\x39\x63"
  }

  firebaseStorageFolder = 'prescription-files/';

  constructor() {
    this.app = initializeApp(this.firebaseConfig);
    this.storage = getStorage(this.app);
  }

  _uniqFilename() {
    return String(Date.now().toString(32) + Math.random().toString(16)).replace(/\./g, '');
  }

  _getExtension(filename) {
    let basename = filename.split(/[\\/]/).pop(),
      pos = basename.lastIndexOf(".");
    if (basename === '' || pos < 1)
      return '';
    return basename.slice(pos + 1);
  }

  uploadFile(file, callbackSuccess, callbackSnapshot, callbackError) {

    if (file.size > this.maxFileSize) {
      let maxFileSizeMB =  this.maxFileSize / 1024 / 1024;
      callbackError('File size exceeds maximum limit ' + maxFileSizeMB + ' MB.');
      return false;
    }

    const firebaseStorageFilename = this._uniqFilename() + '.' + this._getExtension(file.name);

    const storageRef = ref(this.storage, this.firebaseStorageFolder + firebaseStorageFilename);

    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on('state_changed',
      (snapshot) => {
        if (typeof(callbackSnapshot) === 'function') {
          callbackSnapshot(snapshot);
        }
      },
      (error) => {
        if (typeof(callbackError) === 'function') {
          let errorMessage = 'File Upload failed, please try it again with different file.';
          callbackError(errorMessage);
        }
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          if (typeof(callbackSuccess) === 'function') {
            callbackSuccess(downloadURL);
          }
        }).catch((error) => { /* A full list of error codes is available at https://firebase.google.com/docs/storage/web/handle-errors | var: error.code */
          let errorMessage = 'File Upload failed, please try it again with different file.';
          if (typeof(callbackError) === 'function') {
            callbackError(errorMessage);
          }
        });
      }
    );
  }
}

class FirebaseFileUploadEl extends HTMLElement {
  constructor() {
    super();
    this.firebaseFileUpload = new FirebaseFileUpload();

    this.fileInput = this.querySelector('input[type="file"]');
    this.fileInput.accept = this.firebaseFileUpload.acceptedFiles;
    this.fileInput.addEventListener('change', (event) => {
      event.preventDefault();

      this._reset();

      if (event.target.files !== undefined && event.target.files[0] !== undefined) {
        this._hide(this.fileInput);
        this._show(this.uploadProgress);

        this.uploadFile(event.target.files[0]);
      }
    });

    this.uploadButton = this.querySelector('label[for="firebase-file-upload-file"]');

    this.downloadUrlInput = this.querySelector('.firebase-file-upload-downloadUrl');

    this.uploadProgress = this.querySelector('.upload-progress');
    this.uploadProgressIndicator = this.uploadProgress.querySelector('.upload-progress--bar--indicator');
    this.uploadProgressPercent = this.uploadProgress.querySelector('.upload-progress--percent');

    this.uploadResult = this.querySelector('.upload-result');
    this.uploadResultFilename = this.uploadResult.querySelector('.upload-result--filename');
    this.uploadResultDelete = this.uploadResult.querySelector('.upload-result--delete');
    this.uploadResultDelete.addEventListener('click', (event) => {
      event.preventDefault();
      this._reset();
    });

    this.uploadError = this.querySelector('.upload-error');
    this.uploadErrorMessage = this.uploadError.querySelector('.upload-error--message');

    this._reset();
  }
  
  _reset() {
    this.uploadResultFilename.innerText = '';
    this.uploadErrorMessage.innerText = '';
    this.uploadProgressPercent.innerText = '0%';
    this.uploadProgressIndicator.style.width = '0';
    this.downloadUrlInput.value = '';
    // this.downloadUrlInput.disabled = 'true';
    this._hide(this.uploadResult);
    this._hide(this.uploadProgress);
    this._hide(this.uploadError);
    this._show(this.uploadButton);
  }

  _hide(el) {
    el.setAttribute('aria-hidden', 'true');
  }

  _show(el) {
    el.removeAttribute('aria-hidden');
  }

  uploadFile(file) {
    this.firebaseFileUpload.uploadFile(file,
      (downloadURL) => {
        this.downloadUrlInput.value = downloadURL;
        this.downloadUrlInput.removeAttribute('disabled');

        const firebaseFileUploadSuccessEvent = new CustomEvent('firebaseFileUploadSuccess', {
          detail: { file: file, downloadURL: downloadURL }, bubbles: false, cancelable: true, composed: false
        });
        this.fileInput.dispatchEvent(firebaseFileUploadSuccessEvent);

        this._hide(this.uploadProgress);

        this.uploadResultFilename.innerHTML = file.name;

        this._show(this.uploadResult);
      },
      (snapshot) => {
        const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        this.uploadProgressPercent.innerText = progress + '%';
        this.uploadProgressIndicator.style.width = progress + '%';
      },
      (errorMessage) => {
        this._reset();
        this._hide(this.fileInput);

        this.uploadErrorMessage.innerText = errorMessage;
        this._show(this.uploadError);
      }
    );
  }
}

customElements.define('firebase-file-upload', FirebaseFileUploadEl);
